import { Observable } from 'rxjs'
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators'
import { isEqual } from 'lodash'

export const deepDistinctUntilChanged = <T>() => distinctUntilChanged((x: T, y: T) => isEqual(x, y))
export const switchTap = <T, U>(action$: (input: T) => Observable<U>) =>
  switchMap((x: T) => action$(x).pipe(map(() => x)))
